// ==================== HOOK USEDEBOUNCE ====================
// Este hook retrasa la actualización de un valor para evitar
// búsquedas excesivas mientras el usuario escribe

import { useState, useEffect } from 'react';

/**
 * Hook para hacer debounce de un valor
 * @param {any} value - El valor a hacer debounce
 * @param {number} delay - Milisegundos de retraso (default: 500ms)
 * @returns {any} El valor con debounce aplicado
 * 
 * Ejemplo:
 * const [searchTerm, setSearchTerm] = useState('');
 * const debouncedSearch = useDebounce(searchTerm, 500);
 * 
 * // debouncedSearch se actualiza 500ms después de que el usuario
 * // deje de escribir
 */
export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Establecer un timeout para actualizar el valor después del delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpiar el timeout si el valor cambia antes de que se cumpla el delay
    // Esto previene actualizaciones innecesarias
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
